export const properties = {
  userNamePattern: '^[a-zA-Z0-9]+([a-zA-Z0-9](_|-|)[a-zA-Z0-9])*[a-zA-Z0-9]+$',
  imageExtension: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
  defaultUserImage: '../assets/img/profile.jpg',
  defaultBranchImage: '../assets/img/branch.jpg',
  maps: {
    defaultLocation: {
      latitude: 18.47,
      longitude: -69.96582
    },
    zoom: 13
  },
  ordersTime: 30
};
